import { BeneficioApi as Api } from "./beneficio.api";

export class BeneficioFacade {
  static async countByComercioId(comercioId) {
    return Api.countByComercioId(comercioId);
  }

  static async getListByComercioWithPagination(comercioId, pagination) {
    return Api.getListByComercioIdWithPagination(comercioId, pagination);
  }
}
